{
  "You're invited to watch {title}": "「{title}」の配信にご招待します",
  "Share your event link": "イベントリンクを共有",
  "device|desktop": "パソコン",
  "device|phone": "スマートフォン",
  "device|tablet": "タブレット",
  "device|tv": "テレビ",
  "device|console": "ゲーム機",
  "{hours}h {minutes}m": "{hours}時間{minutes}分",
  "Sorry, there's been an error loading the analytics data.": "申し訳ありません。分析データの読み込み中にエラーが発生しました。",
  "Detailed analytics are available for events starting May 20, 2025. Below are the basic statistics for this event.": "詳細な分析は、2025年5月20日以降に開始したイベントでご利用いただけます。以下は、このイベントの基本的な統計です。",
  "Viewed Live": "ライブで視聴",
  "Watched Replay": "録画で視聴",
  "Powered by": "提供：",
  "{count} views": {
    "other": "{count}回視聴"
  },
  "{count} viewers": {
    "other": "視聴者{count}人"
  },
  "Analytics are kept for 100 days. Export a PDF to keep a copy.": "分析データは100日間保存されます。コピーを残すには、PDFをエクスポートしてください。",
  "Total Views": "総視聴回数",
  "Unique Viewers": "ユニーク視聴者数",
  "Total Watch Time": "総視聴時間",
  "Views": "視聴回数",
  "Watch Time": "視聴時間",
  "Top Countries": "上位の国",
  "Top Regions / States": "上位の地域・州",
  "analytics|Unknown": "不明",
  "Device Categories": "デバイスの種類",
  "Top Browsers": "上位のブラウザ",
  "Operating Systems": "OS",
  "Import": "インポート",
  "Invite a guest": "ゲストを招待",
  "We'll email them the event link and remind them before you go live.": "ゲストにイベントリンクをメールで送り、ライブ配信の開始前にリマインダーもお送りします。",
  "CSV Import": "CSVインポート",
  "Select File": "ファイルを選択",
  "Format: CSV. Required column: Email. Optional columns: Name, First Name, Last Name": "形式：CSV。必須の列：Email。任意の列：Name、First Name、Last Name（列名は英語のまま）",
  "Invite All ({count})": "全員を招待（{count}）",
  "Couldn't load the guest list": "ゲストリストを読み込めませんでした",
  "Remove the guest from the list?": "このゲストをリストから削除しますか？",
  "guest status|Joined Live": "ライブに参加",
  "guest status|Watched Replay": "録画を視聴",
  "guest status|Visited page": "ページを訪問",
  "guest status|Invited": "招待済み",
  "{count} guest": {
    "other": "ゲスト{count}人"
  },
  "Open the guest list": "ゲストリストを開く",
  "Guests of every {noun} are on the guest list of {label} (the main link). They sign up once and can watch every {noun}.": "すべての{noun}のゲストは、{label}（メインのリンク）のゲストリストに登録されます。ゲストは一度登録するだけで、すべての{noun}を視聴できます。",
  "Start inviting guests": "ゲストを招待しましょう",
  "Invite guests by email or just share your event link with them.": "メールでゲストを招待するか、イベントリンクを共有してください。",
  "Guests who sign the guestbook or ask for reminders appear here too.": "ゲストブックに記帳したゲストや、リマインダーを申し込んだゲストもここに表示されます。",
  "Share link": "リンクを共有",
  "Download guest list": "ゲストリストをダウンロード",
  "Guests {title}.csv": "ゲストリスト_{title}.csv",
  "Guests.csv": "ゲストリスト.csv",
  "{title}-report.pdf": "{title}-レポート.pdf",
  "analytics-report.pdf": "分析レポート.pdf",
  "Export PDF": "PDFをエクスポート",
  "Invitation sent": "招待状を送信しました",
  "{name} will get reminders before you go live.": "ライブ配信の開始前に、{name}さんにリマインダーが届きます。",
  "Couldn't send the invitation": "招待状を送信できませんでした",
  "Guest's name": "ゲストの名前",
  "e.g. Maria Lopez": "例：山田花子",
  "Send invitation": "招待状を送信",
  "Could not open image library.": "写真ライブラリを開けませんでした。",
  "Delete Cover?": "カバー画像を削除しますか？",
  "Delete failed": "削除できませんでした",
  "Processing image...": "画像を処理しています…",
  "Uploading... {percent}%": "アップロード中…{percent}%",
  "Invalid file": "無効なファイルです",
  "Only JPG or PNG files are accepted": "JPGまたはPNGファイルのみ使用できます",
  "Drop image here": "ここに画像をドロップ",
  "Drop image here or click to select": "ここに画像をドロップするか、クリックして選択",
  "Recommended size: 1280x720 pixels": "推奨サイズ：1280x720ピクセル",
  "Accepts PNG or JPG under 50MB": "50MB未満のPNGまたはJPGに対応",
  "Couldn't save that": "保存できませんでした",
  "Guests who watch on your website get emails that link back to the page they watched on.": "ウェブサイトで視聴したゲストには、視聴したページへのリンクが記載されたメールが届きます。",
  "Pages where guests watch your embed will show up here.": "ゲストが埋め込みを視聴したページがここに表示されます。",
  "Seen on": "視聴されたページ",
  "Use for email links": "メールのリンクに使用",
  "Ignore": "無視",
  "Used for email links": "メールのリンクに使用中",
  "Stop using": "使用を停止",
  "Other guests": "その他のゲスト",
  "Your Embed webpage URL from before. Remove it to send everyone else to evt.live.": "以前に設定した、埋め込みを掲載しているウェブページのURLです。削除すると、それ以外のゲストはevt.liveに案内されます。",
  "EventLive event": "EventLiveのイベント",
  "How this event's page looks to guests. It overrides the branding in your profile.": "このイベントのページがゲストにどう表示されるかを設定します。プロフィールのブランディングより優先されます。",
  "Could not update branding settings": "ブランディング設定を更新できませんでした",
  "Event page": "イベントページ",
  "Description": "説明",
  "A few words for your guests": "ゲストへのメッセージ",
  "Supports Markdown: **bold**, lists and links.": "Markdownに対応：**太字**、リスト、リンク。",
  "e.g. 7pm ET / 4pm PT": "例：日本時間19:00／ロンドン時間11:00",
  "Replaces the date and time on your event page and in reminder emails.": "イベントページとリマインダーメールで、日時の代わりに表示されます。",
  "Company": "会社名",
  "Shown on this event page only. PNG or JPG; it's trimmed and resized automatically. Horizontal logos work best. A white logo on a transparent background may not show on a light page.": "このイベントページにのみ表示されます。PNGまたはJPG形式で、余白の切り取りとサイズ調整は自動で行われます。横長のロゴがおすすめです。透明な背景の白いロゴは、明るいページでは見えない場合があります。",
  "Put your event page or just the video player on your own website.": "イベントページ、または動画プレーヤーだけを、ご自身のウェブサイトに掲載できます。",
  "Layout": "レイアウト",
  "Full embed": "フル埋め込み",
  "The event page: video, guestbook and reminders.": "イベントページ全体：動画、ゲストブック、リマインダー。",
  "Just video": "動画のみ",
  "Only the video player.": "動画プレーヤーのみ。",
  "These change the code below. Copy it again after changing them.": "これらの設定を変更すると、下のコードが変わります。変更後はコードをもう一度コピーしてください。",
  "Autoplay": "自動再生",
  "Start the video automatically.": "動画を自動的に再生します。",
  "Reminder button": "リマインダーボタン",
  "Guests can sign up for reminders from your website.": "ゲストがウェブサイト上でリマインダーを申し込めます。",
  "No replay and no rewind in the embed.": "埋め込みでは録画の視聴も巻き戻しもできません。",
  "Script (recommended)": "スクリプト（推奨）",
  "Viewers who open an EventLive email link on your page are recognized there, and the player is sized to fit.": "EventLiveのメールに記載されたリンクからウェブサイトを開いた視聴者が認識され、プレーヤーのサイズも自動で調整されます。",
  "Simple iframe (no script)": "シンプルなiframe（スクリプトなし）",
  "For site builders that remove scripts. The player can't see viewers' email links, so ticket holders on a new device may have to sign in again.": "スクリプトを削除するサイトビルダー向けです。プレーヤーが視聴者のメールのリンクを認識できないため、チケットをお持ちの方が新しいデバイスで視聴する場合は、再度ログインが必要になることがあります。",
  "Embed code": "埋め込みコード",
  "Copy embed code": "埋め込みコードをコピー",
  "Embed code copied": "埋め込みコードをコピーしました",
  "Paste it into your website's HTML.": "ウェブサイトのHTMLに貼り付けてください。",
  "Preview": "プレビュー",
  "Couldn't load the guestbook": "ゲストブックを読み込めませんでした",
  "Delete this message?": "このメッセージを削除しますか？",
  "Messaging": "メッセージ機能",
  "Chat": "チャット",
  "You pinned": "あなたが固定",
  "Delete this message": "このメッセージを削除",
  "Could not update messaging settings": "メッセージ機能の設定を更新できませんでした",
  "Guests sign it and add photos. Newest messages first.": "ゲストが記帳し、写真を追加できます。新しいメッセージが先頭に表示されます。",
  "A live chat next to the video, like a group conversation.": "動画の横に表示される、グループ会話のようなライブチャットです。",
  "Disable messaging": "メッセージ機能をオフにする",
  "Guests can watch but can't post messages.": "ゲストは視聴できますが、メッセージは投稿できません。",
  "{count} message": {
    "other": "メッセージ{count}件"
  },
  "Loading messages…": "メッセージを読み込んでいます…",
  "No messages yet. They'll appear here as guests post them.": "メッセージはまだありません。ゲストが投稿すると、ここに表示されます。",
  "Could not update privacy settings": "プライバシー設定を更新できませんでした",
  "Hide event page": "イベントページを非表示にする",
  "Manage tickets": "チケットを管理",
  "Guests need a ticket to watch. To let some guests in for free, invite them from the Guest List.": "視聴にはチケットが必要です。一部のゲストを無料で入場させるには、ゲストリストから招待してください。",
  "Anyone with the link can watch": "リンクを知っている人は誰でも視聴可能",
  "Share the link; no password or invitation needed.": "リンクを共有するだけです。パスワードや招待は不要です。",
  "Password protected": "パスワード保護",
  "Guests enter a password you give them.": "ゲストは、あなたが伝えたパスワードを入力します。",
  "Choose a password": "パスワードを設定",
  "Invite only": "招待制",
  "Only the guests invited by email can join. One device per email at a time. (MUST be on the <list>Guest List</list>)": "メールで招待されたゲストのみ参加できます。1つのメールアドレスにつき、同時に視聴できるのは1台のデバイスのみです。（必ず<list>ゲストリスト</list>に登録してください）",
  "Ask guests for their name and email": "ゲストに名前とメールアドレスの入力を求める",
  "Always on for invite-only events.": "招待制のイベントでは常にオンです。",
  "Before they can watch. They'll appear in your Guest List.": "視聴前に入力してもらいます。入力したゲストはゲストリストに表示されます。",
  "Replay and download": "録画とダウンロード",
  "Show download link to guests": "ゲストにダウンロードリンクを表示",
  "Hide viewer counter": "視聴者数カウンターを非表示",
  "Your event page is hidden. People who bought tickets can't watch until you show it again.": "イベントページは非表示になっています。ページを再び表示するまで、チケットを購入した方は視聴できません。",
  "Your event page is hidden. Guests can't open it until you show it again.": "イベントページは非表示になっています。ページを再び表示するまで、ゲストはページを開けません。",
  "Show event page": "イベントページを表示する",
  "Remove {guest} from the guest list": "{guest}をゲストリストから削除",
  "Message pinned": "メッセージを固定しました",
  "Guests see it at the top of the guestbook.": "ゲストブックの一番上に表示されます。",
  "Couldn't pin the message": "メッセージを固定できませんでした",
  "e.g. Welcome! The ceremony starts at 3 pm.": "例：ようこそ！式は15時に始まります。",
  "Stays at the top of the guestbook or chat.": "ゲストブックまたはチャットの一番上に表示され続けます。",
  "Pin message": "メッセージを固定",
  "Share on {network}": "{network}で共有",
  "Share on Email": "メールで共有",
  "Preview my Event Page": "イベントページをプレビュー",
  "Share via:": "共有方法：",
  "Viewer-hours": "延べ視聴時間",
  "{count} viewer-hour": {
    "other": "延べ視聴{count}時間"
  },
  "Live {live} · Replay {replay}": "ライブ{live}・録画{replay}",
  "Ticketed events have no viewer-hour limit.": "チケット制のイベントには、延べ視聴時間の上限がありません。",
  "{used} of {limit} viewer-hours included with this event": "このイベントに含まれる延べ視聴時間{limit}時間のうち、{used}時間を使用",
  "Over the {limit} viewer-hours included with this event by {over}.": "このイベントに含まれる延べ視聴時間{limit}時間を{over}時間超えています。",
  "By day (UTC)": "日別（UTC）",
  "Show fewer days": "表示する日数を減らす",
  "Show all {count} days": {
    "other": "全{count}日間を表示"
  },
  "Viewer-hours are updated every hour. They show here within an hour of people watching.": "延べ視聴時間は1時間ごとに更新されます。視聴から1時間以内にここに反映されます。",
  "Counted every hour from the video our CDN delivered, on every player. Viewing before {date} isn't included. Updated {updated}.": "すべてのプレーヤーを対象に、当社のCDNが配信した動画をもとに1時間ごとに集計しています。{date}より前の視聴は含まれません。最終更新：{updated}。",
  "Counted every hour from the video our CDN delivered, on every player. Updated {updated}.": "すべてのプレーヤーを対象に、当社のCDNが配信した動画をもとに1時間ごとに集計しています。最終更新：{updated}。",
  "Live viewers": "ライブ視聴者数",
  "Devices watching each minute of the live stream.": "ライブ配信の1分ごとに、視聴していたデバイスの数です。",
  "Live viewers per minute from {start} to {end}. Peak: {peak} at {time}.": "{start}〜{end}の1分ごとのライブ視聴者数。最大：{peak}人（{time}）。",
  "Peak: {count} at {time}": "最大：{count}人（{time}）",
  "{count} viewer at {time}": {
    "other": "{time}の視聴者：{count}人"
  },
  "Updated every hour, for every player, and kept for good.": "すべてのプレーヤーを対象に1時間ごとに更新され、無期限で保存されます。",
  "Browsers and apps": "ブラウザとアプリ",
  "{count} viewer": {
    "other": "視聴者{count}人"
  },
  "Regions:": "地域：",
  "IP Geolocation by DB-IP": "IP位置情報の提供：DB-IP",
  "Before {date}": "{date}より前",
  "From our previous analytics, which counted browsers only, saved for good before they expired.": "ブラウザのみを集計していた以前の分析データです。期限切れになる前に、無期限で保存しました。",
  "Viewers": "視聴者",
  "{live} live · {replay} replay only": "ライブ{live}人・録画のみ{replay}人",
  "{time} per viewer": "視聴者1人あたり{time}",
  "Peak live viewers": "最大同時視聴者数",
  "Watch time, views, countries and devices are counted from {date}. Unique viewers are counted for every event.": "視聴時間、視聴回数、国、デバイスは{date}から集計しています。ユニーク視聴者数は、すべてのイベントで集計しています。",
  "Viewers here are devices on each day: someone watching on two days counts twice. Counted every hour from the video our CDN delivered, on every player.": "ここでの視聴者数は日ごとのデバイス数です。2日間視聴した人は2回カウントされます。すべてのプレーヤーを対象に、当社のCDNが配信した動画をもとに1時間ごとに集計しています。",
  "Mux, for comparison": "比較用：Mux",
  "The previous report: the last 100 days, browsers that report to Mux only.": "以前のレポート：過去100日間、Muxにデータを送信するブラウザのみ。",
  "analytics|Other": "その他",
  "Analytics are updated every hour. They show here within an hour of people watching.": "分析データは1時間ごとに更新されます。視聴から1時間以内にここに反映されます。",
  "Counted from {date}; the viewing before it is further down.": "{date}から集計しています。それ以前の視聴は下に表示されています。",
  "Counted from {date}; the viewing before it wasn't counted.": "{date}から集計しています。それ以前の視聴は集計されていません。",
  "Live viewing during {times} isn't fully counted: our video network didn't save all its logs for that time.": "{times}のライブ視聴は一部集計されていません。当社の動画配信ネットワークが、その時間帯のログをすべて保存できなかったためです。",
  "This event keeps its current report until {date}. Then it moves to our new analytics, which count every player and are kept for good. Export a PDF to keep a copy of this report.": "このイベントでは、{date}まで現在のレポートが維持されます。その後、すべてのプレーヤーを集計して無期限で保存する新しい分析に移行します。このレポートのコピーを残すには、PDFをエクスポートしてください。"
}
